export default function parseParticipants (participants) {
  const nonDuplicatedParticipants = Array.from(
    new Map(participants.map(participant => [participant.id, participant])).values()
  )
  const parsedParticipants = nonDuplicatedParticipants.map(participant => 
    ({
      id: participant.id,
      fullname: participant.name_surname
    })
  )

  return parsedParticipants
}
